import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { BroadcasterItem } from './BroadcasterItem';

import { useGetMatchEventsQuery } from 'common/store/modules/api/content-api';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';

// in order of display
const BROADCASTERS = ['Channel 7', 'Foxtel', 'Kayo'];

const filterAndSort = (items) => {
    const filtered = items.filter((item) => BROADCASTERS.includes(item.name));
    const sorted = filtered.sort(
        (a, b) => BROADCASTERS.indexOf(a.name) - BROADCASTERS.indexOf(b.name)
    );
    return sorted;
};

export const Broadcasters = ({ matchId }) => {
    const nav = useSelector(navSelector);
    const selectedRegion = useSelector((state) => state.selectedRegion);

    const { data } = useGetMatchEventsQuery({
        compseason: nav.season.id,
        round: nav.round.roundNumber
    });

    const matchEvent = data?.content?.find(
        (item) => matchId === item.contentReference.id
    );
    let broadcasters = [];
    let orderedBroadcasters = [];

    if (matchEvent) {
        broadcasters = PULSE.app.common.extractBroadcastersFromMatchEvent(
            matchEvent,
            selectedRegion?.id
        );
    }

    if (broadcasters) {
        orderedBroadcasters = filterAndSort(broadcasters);
    }

    return orderedBroadcasters?.length ? (
        <div className="fixtures__broadcaster-container">
            {orderedBroadcasters.map((broadcaster) => {
                return (
                    <BroadcasterItem
                        broadcaster={broadcaster}
                        key={broadcaster.id}
                    />
                );
            })}
        </div>
    ) : (
        <></>
    );
};

Broadcasters.propTypes = {
    matchId: PropTypes.any.isRequired
};
